import apiClient from '../api/apiClient';
import { Location, LocationListResponse } from '../Types/Location';
import { FALLBACK_LOCATIONS } from '../Data/fallbackLocations';

export const getLocations = async (): Promise<{ locations: Location[]; isFallback: boolean }> => {
  try {
    const response = await apiClient.get<LocationListResponse>('/api/locations');
    const data = Array.isArray(response.data?.data) ? response.data.data : [];
    return { locations: data, isFallback: false };
  } catch {
    return { locations: FALLBACK_LOCATIONS, isFallback: true };
  }
};
